export default __webpack_public_path__ + "static/kinetics-3958904888fed0f380b0c350bbc11500.png";